module.exports = __webpack_public_path__ + "img/type4.e31039e2.png";